import * as Sentry from "@sentry/react-router";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { useEffect } from "react";

export function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      console.error(error);

      // Don't report 404s or other expected HTTP errors to Sentry
      if (isRouteErrorResponse(error)) {
        if (error.status >= 500) {
          Sentry.captureException(
            new Error(`Route Error: ${error.status} ${error.statusText}`),
            {
              extra: {
                status: error.status,
                statusText: error.statusText,
                data: error.data,
              },
            },
          );
        }
      } else if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        Sentry.captureException(new Error("Unknown error occurred"), {
          extra: { error },
        });
      }
    }
  }, [error]);

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold">{error.status}</h1>
          <p className="mt-2 text-lg">{error.statusText}</p>
          {error.status === 404 && (
            <p className="mt-4 text-gray-600">
              The page you&apos;re looking for doesn&apos;t exist.
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold">Something went wrong</h1>
        <p className="mt-2 text-lg text-gray-600">
          An unexpected error occurred. Our team has been notified.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}
